module.exports = __webpack_public_path__ + "static/media/tizeti-products.fc408144.jpeg";